module.exports = require("vue-loader/lib/runtime/componentNormalizer.js");